import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Button,
  Input,
  Dropdown
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardTriggerInvoiceitemUX = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        style={{width: "calc(-150px + 100vw)", height:"100%",padding:"10px"}}>
        <div
          style={{padding: "10px 5px 15px", marginBottom: "-10px"}}>
          
          <Form
            id="CardTriggerInvoiceitemUX-Form-126">
            <FormGroup
              id="CardTriggerInvoiceitemUX-FormGroup-129"
              inline={true}
              style={{ marginBottom: "0px"}}>
              <FormField
                id="CardTriggerInvoiceitemUX-FormField-131"
                inline={true}
                width={2}>
                <label
                  id="CardTriggerInvoiceitemUX-label-169">
                  {props.languageUX === "en" ? "HN" : "HN"}
                </label>
              </FormField>
              <FormField
                id="CardTriggerInvoiceitemUX-FormField-132"
                inline={true}
                width={2}>
                <label
                  id="CardTriggerInvoiceitemUX-label-168">
                  {props.languageUX === "en" ? "By Status" : "ตามสถานะ"}
                </label>
              </FormField>
              <FormField
                id="CardTriggerInvoiceitemUX-FormField-133"
                inline={true}
                width={2}>
                <label
                  id="CardTriggerInvoiceitemUX-label-167">
                  {props.languageUX === "en" ? "By Type" : "ตามประเภท"}
                </label>
              </FormField>
              <FormField
                id="CardTriggerInvoiceitemUX-FormField-134"
                inline={true}
                width={3}>
                <label
                  id="CardTriggerInvoiceitemUX-label-166">
                  {props.languageUX === "en" ? "By Bill Mode" : "โดยโหมดบิล"}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardTriggerInvoiceitemUX-FormGroup-130"
              inline={true}>
              <FormField
                id="CardTriggerInvoiceitemUX-FormField-135"
                inline={true}
                width={2}>
                <div
                  id="CardTriggerInvoiceitemUX-div-148"
                  style={{ width: "100%" }}>
                  
                  <Input
                    fluid={true}
                    id="CardTriggerInvoiceitemUX-Input-154"
                    name="hn"
                    onChange={props.onChangeData}
                    value={props.searchTriggerInvoice?.hn || ""}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardTriggerInvoiceitemUX-FormField-136"
                inline={true}
                width={2}>
                <div
                  id="CardTriggerInvoiceitemUX-div-147"
                  style={{ width: "100%" }}>
                  
                  <Dropdown
                    clearable={true}
                    fluid={true}
                    id="CardTriggerInvoiceitemUX-Dropdown-157"
                    name="status"
                    onChange={props.onChangeData}
                    options={props.statusInvoiceOption}
                    selection={true}
                    value={props.searchTriggerInvoice?.status || ""}>
                  </Dropdown>
                </div>
              </FormField>
              <FormField
                id="CardTriggerInvoiceitemUX-FormField-137"
                inline={true}
                width={2}>
                <div
                  id="CardTriggerInvoiceitemUX-div-146"
                  style={{ width: "100%" }}>
                  
                  <Dropdown
                    clearable={true}
                    fluid={true}
                    id="CardTriggerInvoiceitemUX-Dropdown-156"
                    name="type"
                    onChange={props.onChangeData}
                    options={props.typeInvoiceOption}
                    selection={true}
                    value={props.searchTriggerInvoice?.type || ""}>
                  </Dropdown>
                </div>
              </FormField>
              <FormField
                id="CardTriggerInvoiceitemUX-FormField-138"
                inline={true}
                width={3}>
                <div
                  id="CardTriggerInvoiceitemUX-div-145"
                  style={{ width: "100%" }}>
                  
                  <Dropdown
                    clearable={true}
                    fluid={true}
                    id="CardTriggerInvoiceitemUX-Dropdown-155"
                    name="billMode"
                    onChange={props.onChangeData}
                    options={props.billModeOption}
                    selection={true}
                    value={props.searchTriggerInvoice?.billMode || ""}>
                  </Dropdown>
                </div>
              </FormField>
              <FormField
                id="CardTriggerInvoiceitemUX-FormField-139"
                inline={true}
                width={2}>
                <div
                  id="CardTriggerInvoiceitemUX-div-144"
                  style={{ display: "flex", width: "100%" }}>
                  
                  <div
                    id="CardTriggerInvoiceitemUX-div-149"
                    style={{ margin: "0px 20px" }}>
                    
                    <div
                      id="CardTriggerInvoiceitemUX-div-152">
                      {props.buttonSeach}
                    </div>
                  </div>
                  <div
                    id="CardTriggerInvoiceitemUX-div-150">
                    
                    <Button
                      color="orange"
                      id="CardTriggerInvoiceitemUX-Button-153"
                      onClick={props.onClickClear}>
                      {props.languageUX === "en" ? "Clear" : "ล้างหน้าจอ"}
                    </Button>
                  </div>
                </div>
              </FormField>
            </FormGroup>
          </Form>
        </div>
        <div
          id="CardTriggerInvoiceitemUX-div-161">
          
          <Table
            className="--rt-tbody-overflow-y-hidden"
            columns={props.triggerInvoiceColumns}
            data={props.triggerInvoiceData}
            id="CardTriggerInvoiceitemUX-Table-165"
            minRows={5}
            onPageChange={props.onPageChange}
            onPageSizeChange={props.onPageSizeChange}
            page={props.paginatedItems?.page || 0}
            pageSize={props.paginatedItems?.pageSize || 0}
            pages={Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)}
            style={{ height: "calc(95vh - 14.5rem)"}}>
          </Table>
        </div>
        <div
          id="CardTriggerInvoiceitemUX-div-162"
          style={{ display: "flex", justifyContent: "flex-end", margin: "20px 0px" }}>
          
          <div
            id="CardTriggerInvoiceitemUX-div-163"
            style={{ margin: "0px 20px" }}>
            
            <div
              id="CardTriggerInvoiceitemUX-div-164">
              {props.buttonTrigger}
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardTriggerInvoiceitemUX

export const screenPropsDefault = {}

/* Date Time : Wed Oct 01 2025 12:48:37 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"calc(-150px + 100vw)\", height:\"100%\",padding:\"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 48,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px 5px 15px\", marginBottom: \"-10px\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 126,
      "name": "Form",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-Form-126"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 129,
      "name": "FormGroup",
      "parent": 126,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-FormGroup-129"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ marginBottom: \"0px\"}"
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 130,
      "name": "FormGroup",
      "parent": 126,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-FormGroup-130"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 131,
      "name": "FormField",
      "parent": 129,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-FormField-131"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 132,
      "name": "FormField",
      "parent": 129,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-FormField-132"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 133,
      "name": "FormField",
      "parent": 129,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-FormField-133"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 134,
      "name": "FormField",
      "parent": 129,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-FormField-134"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 134,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 135,
      "name": "FormField",
      "parent": 130,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-FormField-135"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 136,
      "name": "FormField",
      "parent": 130,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-FormField-136"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 137,
      "name": "FormField",
      "parent": 130,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-FormField-137"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 138,
      "name": "FormField",
      "parent": 130,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-FormField-138"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 139,
      "name": "FormField",
      "parent": 130,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-FormField-139"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": null,
      "id": 144,
      "name": "div",
      "parent": 139,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-div-144"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", width: \"100%\" }"
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": null,
      "id": 145,
      "name": "div",
      "parent": 138,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-div-145"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": null,
      "id": 146,
      "name": "div",
      "parent": 137,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-div-146"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 146,
      "void": false
    },
    {
      "from": null,
      "id": 147,
      "name": "div",
      "parent": 136,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-div-147"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 147,
      "void": false
    },
    {
      "from": null,
      "id": 148,
      "name": "div",
      "parent": 135,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-div-148"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 148,
      "void": false
    },
    {
      "from": null,
      "id": 149,
      "name": "div",
      "parent": 144,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-div-149"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 20px\" }"
        }
      },
      "seq": 149,
      "void": false
    },
    {
      "from": null,
      "id": 150,
      "name": "div",
      "parent": 144,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-div-150"
        }
      },
      "seq": 150,
      "void": false
    },
    {
      "from": null,
      "id": 152,
      "name": "div",
      "parent": 149,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSeach"
        },
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-div-152"
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 153,
      "name": "Button",
      "parent": 150,
      "props": {
        "children": {
          "type": "value",
          "value": "ล้างหน้าจอ",
          "valueEN": "Clear"
        },
        "color": {
          "type": "value",
          "value": "orange"
        },
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-Button-153"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickClear"
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 154,
      "name": "Input",
      "parent": 148,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-Input-154"
        },
        "name": {
          "type": "value",
          "value": "hn"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchTriggerInvoice?.hn || \"\""
        }
      },
      "seq": 154,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 155,
      "name": "Dropdown",
      "parent": 145,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-Dropdown-155"
        },
        "name": {
          "type": "value",
          "value": "billMode"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.billModeOption"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.searchTriggerInvoice?.billMode || \"\""
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 156,
      "name": "Dropdown",
      "parent": 146,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-Dropdown-156"
        },
        "name": {
          "type": "value",
          "value": "type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.typeInvoiceOption"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.searchTriggerInvoice?.type || \"\""
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 157,
      "name": "Dropdown",
      "parent": 147,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-Dropdown-157"
        },
        "name": {
          "type": "value",
          "value": "status"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.statusInvoiceOption"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.searchTriggerInvoice?.status || \"\""
        }
      },
      "seq": 157,
      "void": false
    },
    {
      "from": null,
      "id": 161,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-div-161"
        }
      },
      "seq": 161,
      "void": false
    },
    {
      "from": null,
      "id": 162,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-div-162"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\", margin: \"20px 0px\" }"
        }
      },
      "seq": 162,
      "void": false
    },
    {
      "from": null,
      "id": 163,
      "name": "div",
      "parent": 162,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-div-163"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 20px\" }"
        }
      },
      "seq": 163,
      "void": false
    },
    {
      "from": null,
      "id": 164,
      "name": "div",
      "parent": 163,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonTrigger"
        },
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-div-164"
        }
      },
      "seq": 164,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 165,
      "name": "Table",
      "parent": 161,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "columns": {
          "type": "code",
          "value": "props.triggerInvoiceColumns"
        },
        "data": {
          "type": "code",
          "value": "props.triggerInvoiceData"
        },
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-Table-165"
        },
        "minRows": {
          "type": "code",
          "value": "5"
        },
        "onPageChange": {
          "type": "code",
          "value": "props.onPageChange"
        },
        "onPageSizeChange": {
          "type": "code",
          "value": "props.onPageSizeChange"
        },
        "page": {
          "type": "code",
          "value": "props.paginatedItems?.page || 0"
        },
        "pageSize": {
          "type": "code",
          "value": "props.paginatedItems?.pageSize || 0"
        },
        "pages": {
          "type": "code",
          "value": "Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"calc(95vh - 14.5rem)\"}"
        }
      },
      "seq": 165,
      "void": false
    },
    {
      "from": null,
      "id": 166,
      "name": "label",
      "parent": 134,
      "props": {
        "children": {
          "type": "value",
          "value": "โดยโหมดบิล",
          "valueEN": "By Bill Mode"
        },
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-label-166"
        }
      },
      "seq": 166,
      "void": false
    },
    {
      "from": null,
      "id": 167,
      "name": "label",
      "parent": 133,
      "props": {
        "children": {
          "type": "value",
          "value": "ตามประเภท",
          "valueEN": "By Type"
        },
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-label-167"
        }
      },
      "seq": 167,
      "void": false
    },
    {
      "from": null,
      "id": 168,
      "name": "label",
      "parent": 132,
      "props": {
        "children": {
          "type": "value",
          "value": "ตามสถานะ",
          "valueEN": "By Status"
        },
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-label-168"
        }
      },
      "seq": 168,
      "void": false
    },
    {
      "from": null,
      "id": 169,
      "name": "label",
      "parent": 131,
      "props": {
        "children": {
          "type": "value",
          "value": "HN",
          "valueEN": "HN"
        },
        "id": {
          "type": "value",
          "value": "CardTriggerInvoiceitemUX-label-169"
        }
      },
      "seq": 169,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 100,
  "isMounted": true,
  "memo": false,
  "name": "CardTriggerInvoiceitemUX",
  "project": "CLM CU",
  "screenPropsDefault": {
  },
  "width": 100
}

*********************************************************************************** */
